import { useEffect } from 'react';
import PropTypes from 'prop-types';
import useUserStore from '../store/userStore';
import useUserFeaturesStore from '../store/userFeaturesStore';

/**
 * Provider component để tự động fetch features khi user đăng nhập
 * Đặt component này ở root của app (trong App.jsx hoặc Layout)
 */
const FeatureProvider = ({ children }) => {
  const user = useUserStore((state) => state.user);
  const { fetchUserFeatures, clearCache } = useUserFeaturesStore();

  useEffect(() => {
    if (user) {
      // User đã đăng nhập -> fetch features
      fetchUserFeatures();
    } else {
      // User đã logout -> clear cache
      clearCache();
    }
  }, [user, fetchUserFeatures, clearCache]);

  return children;
};

FeatureProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FeatureProvider;

